"use strict";
var Ajv = require('ajv');
var gpsPointSchema = require('./gpsPointSchema');
var ajv = Ajv({
    allErrors: true
});
var validateGpsPoint = function validateGpsPoint() {
    for (var _len = arguments.length, extraRequiredProperties = new Array(_len), _key = 0; _key < _len; _key++) {
        extraRequiredProperties[_key] = arguments[_key];
    }
    var validate = ajv.compile(gpsPointSchema.apply(undefined, extraRequiredProperties));
    return function (gpsPointJson) {
        var isValid = validate(gpsPointJson);
        if (isValid)
            return true;
        return ajv.errorsText(validate.errors);
    };
};
module.exports = validateGpsPoint;
